export default __webpack_public_path__ + "bar-chart-dark.787e0530.svg";